import ImportanceIndicator from "../../../../../../packages/design-system/src/ImportanceIndicator";
import Spacings from "../../../../../../packages/design-system/src/Spacings";
import Text from "../../../../../../packages/design-system/src/Text";
import * as React from 'react';
export default {
  ImportanceIndicator,
  Spacings,
  Text,
  React
};